import styled from 'styled-components';

export const HeadlineContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 35px;
`;

export const ButtonContainer = styled.div`
  display: flex;

  button:first-child {
    margin-right: 20px;
  }
`;
